const env = require('../helpers/env.js');

// @todo can we test for this instead?

module.exports = () => ['Chrome', 'Opera', 'Safari'].indexOf(env.name) > -1;
